/**
 * Intercom Messenger Integration
 * Handles the Intercom widget and provides utility functions
 */

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || 'on5kg6ru';

/**
 * Initialize Intercom - loads the script
 */
export const initIntercom = () => {
  // Load Intercom script
  (function(){
    var w=window;
    var ic=w.Intercom;
    if(typeof ic==="function"){
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d=document;
      var i=function(){i.c(arguments);};
      i.q=[];
      i.c=function(args){i.q.push(args);};
      w.Intercom=i;
      var l=function(){
        var s=d.createElement('script');
        s.type='text/javascript';
        s.async=true;
        s.src='https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
        var x=d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s,x);
      };
      if(document.readyState==='complete'){
        l();
      } else if(w.attachEvent){
        w.attachEvent('onload',l);
      } else {
        w.addEventListener('load',l,false);
      }
    }
  })();
};

/**
 * Boot Intercom with optional user data
 */
export const bootIntercom = (user = null) => {
  const settings = {
    app_id: INTERCOM_APP_ID,
  };
  
  if (user) {
    settings.name = user.name;
    settings.email = user.email;
    settings.user_id = user.id;
    if (user.phone) {
      settings.phone = user.phone;
    }
    if (user.company_name) {
      settings.company = {
        company_id: user.id,
        name: user.company_name
      };
    }
  }
  
  if (window.Intercom) {
    window.Intercom('boot', settings);
  }
};

/**
 * Update Intercom with new user data
 */
export const updateIntercom = (data = {}) => {
  if (window.Intercom) {
    window.Intercom('update', data);
  }
};

/**
 * Show the Intercom messenger
 */
export const showIntercom = () => {
  if (window.Intercom) {
    window.Intercom('show');
  }
};

/**
 * Hide the Intercom messenger
 */
export const hideIntercom = () => {
  if (window.Intercom) {
    window.Intercom('hide');
  }
};

/**
 * Show Intercom with a new message pre-filled
 */
export const showNewMessage = (message = '') => {
  if (window.Intercom) {
    window.Intercom('showNewMessage', message);
  }
};

/**
 * Show the messages/conversations list
 */
export const showMessages = () => {
  if (window.Intercom) {
    window.Intercom('showMessages');
  }
};

/**
 * Show a specific conversation by ID
 */
export const showConversation = (conversationId) => {
  if (window.Intercom) {
    window.Intercom('showConversation', conversationId);
  }
};

/**
 * Shutdown Intercom (on logout)
 */
export const shutdownIntercom = () => {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
};

/**
 * Track an event
 */
export const trackEvent = (eventName, metadata = {}) => {
  if (window.Intercom) {
    window.Intercom('trackEvent', eventName, metadata);
  }
};

export default {
  init: initIntercom,
  boot: bootIntercom,
  update: updateIntercom,
  show: showIntercom,
  hide: hideIntercom,
  showNewMessage,
  showMessages,
  shutdown: shutdownIntercom,
  trackEvent
};
